import { ReactElement } from 'react'

import type { RangeValueType } from 'rc-picker/lib/PickerInput/RangePicker'

import { UtcDatePicker } from 'components/UtcDatePicker/UtcDatePicker'
import type { Dayjs } from 'configuration/dayjs'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikDateRangePickerProps<V> = FormikWithCustomHandlersProps<V>

function FormikDateRangePicker<
    V extends RangeValueType<Dayjs> | null | undefined,
>({
    field: { value },
    form,
    handleChange,
    handleBlur,
    handleClick,
    ...props
}: FormikDateRangePickerProps<V>): ReactElement {
    return (
        <UtcDatePicker.RangePicker
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            {...props}
        />
    )
}

export default withCustomHandlers(FormikDateRangePicker)
